import { ActionContext, Module } from 'vuex'
import { CustomMenuLinkService, OauthService } from '../services'
import { CustomMenus, CustomPages, RootState } from '../store/state_models'

export const customMenuLinks: Module<CustomMenus, RootState> = {
  namespaced: true,
  state: {
    customMenus: [] as any,
    totalLinks: Number
  },
  getters: {
    get(state: any) {
      return state.customMenus
    },
  },
  actions: {
    fetch(
      context: ActionContext<CustomMenus, RootState>,
      data: { companyId: string; locationId?: string, skip: number; limit: number }
    ) {
      return new Promise(async (resolve, reject) => {
        try {
          if (context.state.customMenus?.length) {
            return resolve(context.state)
          }
          const customMenuResponse = await CustomMenuLinkService.getCustomMenuLink(
            data.companyId,
            data.skip,
            data.limit,
            data.locationId,
          )
          context.commit('add', { customMenus: customMenuResponse.customMenus, totalLinks: customMenuResponse.totalLinks })
          return resolve({customMenus : customMenuResponse.customMenus, totalLinks: customMenuResponse.totalLinks})
        } catch (e) {
          reject()
        }
      })
    },
  },
  mutations: {
    add: (state: CustomMenus, payload: any) => {
      state.customMenus = payload.customMenus
      state.totalLinks = payload.totalLinks
    },
    remove: (state: CustomMenus) => {
      state.customMenus = []
      state.totalLinks = null
    },
  },
}
